import React from 'react';
import { ShieldCheck, Battery, Clock } from 'lucide-react';
export function SystemReveal() {
  return <section className="py-20 md:py-28 bg-[#F5E6D3] text-[#3D2B1F]" data-id="element-131">
      <div className="max-w-5xl mx-auto px-6" data-id="element-132">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-133">
          <h2 className="font-serif text-3xl md:text-5xl font-bold mb-6" data-id="element-134">
            La calma no es un sentimiento. <br data-id="element-135" />
            <span className="text-[#E8856C]" data-id="element-136">Es una estructura.</span>
          </h2>
          <p className="text-lg md:text-xl opacity-90 leading-relaxed" data-id="element-137">
            No te estoy vendiendo “paz interior”. Te estoy dando un modo
            operativo para que tu vida deje de sentirse como una emergencia.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-138">
          {/* Card 1 */}
          <div className="bg-[#FFF8F0] rounded-2xl p-8 shadow-lg border-b-4 border-[#E8856C] hover:-translate-y-1 transition-transform duration-300" data-id="element-139">
            <div className="w-14 h-14 bg-[#E8856C]/10 rounded-full flex items-center justify-center mb-6 text-[#E8856C]" data-id="element-140">
              <ShieldCheck className="w-8 h-8" data-id="element-141" />
            </div>
            <h3 className="font-serif text-2xl font-bold mb-3" data-id="element-142">
              3 No-Negociables
            </h3>
            <p className="text-[#3D2B1F]/80 leading-relaxed" data-id="element-143">
              Lo mínimo que sostiene tu día. Sin ambición, sin perfección. Solo
              lo esencial para que tú y tu casa funcionen.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-[#FFF8F0] rounded-2xl p-8 shadow-lg border-b-4 border-[#E8856C] hover:-translate-y-1 transition-transform duration-300" data-id="element-144">
            <div className="w-14 h-14 bg-[#E8856C]/10 rounded-full flex items-center justify-center mb-6 text-[#E8856C]" data-id="element-145">
              <Battery className="w-8 h-8" data-id="element-146" />
            </div>
            <h3 className="font-serif text-2xl font-bold mb-3" data-id="element-147">
              3 Resets de 3 min
            </h3>
            <p className="text-[#3D2B1F]/80 leading-relaxed" data-id="element-148">
              Porque si tu cuerpo está en alarma, tú no decides: reaccionas.
              Aprende a bajar el voltaje en tiempo real.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-[#FFF8F0] rounded-2xl p-8 shadow-lg border-b-4 border-[#E8856C] hover:-translate-y-1 transition-transform duration-300" data-id="element-149">
            <div className="w-14 h-14 bg-[#E8856C]/10 rounded-full flex items-center justify-center mb-6 text-[#E8856C]" data-id="element-150">
              <Clock className="w-8 h-8" data-id="element-151" />
            </div>
            <h3 className="font-serif text-2xl font-bold mb-3" data-id="element-152">
              3 Límites Simples
            </h3>
            <p className="text-[#3D2B1F]/80 leading-relaxed" data-id="element-153">
              Para que el caos (y la gente) no se coma tu energía. Protege tu
              espacio mental sin culpa.
            </p>
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-154">
          <div className="inline-block bg-[#3D2B1F] text-[#FFF8F0] px-6 py-3 rounded-full font-medium text-lg" data-id="element-155">
            “Pero yo no tengo tiempo”
          </div>
          <p className="mt-6 text-xl md:text-2xl font-serif max-w-2xl mx-auto" data-id="element-156">
            Exacto. Por eso esto no te pide una hora. Te pide{' '}
            <span className="text-[#E8856C] font-bold underline decoration-2 underline-offset-4" data-id="element-157">
              3 minutos
            </span>
            .
          </p>
        </div>
      </div>
    </section>;
}